/* David Pladen — cart timer (snippets/dp-cart-body.liquid [data-dp-timer]).
 * Starts when the cart goes from empty to filled and keeps running across
 * pages (localStorage). At zero the cart is emptied through /cart/clear.js
 * and the drawer is re-rendered. An empty cart resets the timer.
 */

(() => {
  if (window.dpCartTimer) return;
  window.dpCartTimer = true;

  const KEY = 'dp-cart-timer';
  let clearing = false;

  const read = () => {
    try {
      return parseInt(localStorage.getItem(KEY), 10) || 0;
    } catch (e) {
      return 0;
    }
  };

  const write = (value) => {
    try {
      if (value) localStorage.setItem(KEY, String(value));
      else localStorage.removeItem(KEY);
    } catch (e) {}
  };

  const format = (ms) => {
    const s = Math.max(0, Math.ceil(ms / 1000));
    return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
  };

  const expire = async () => {
    clearing = true;
    write(0);
    const url = `${window.Shopify?.routes?.root || '/'}cart/clear.js`;
    const cart = document.querySelector('.dp-cart[data-section-id]');
    try {
      if (cart && typeof cart.request === 'function') {
        await cart.request(url, {});
      } else {
        await fetch(url, { method: 'POST', headers: { Accept: 'application/json' } });
        window.location.reload();
      }
    } finally {
      clearing = false;
    }
  };

  const tick = () => {
    if (clearing) return;
    const el = document.querySelector('[data-dp-timer]');
    if (!el) return;
    if (!(parseInt(el.dataset.count, 10) > 0)) {
      write(0);
      return;
    }
    const duration = (parseFloat(el.dataset.minutes) || 5) * 60000;
    const now = Date.now();
    let start = read();
    if (!start || start > now) {
      start = now;
      write(start);
    }
    const left = start + duration - now;
    document.querySelectorAll('[data-dp-timer-time]').forEach((time) => {
      time.textContent = format(left);
    });
    if (left <= 0) expire();
  };

  tick();
  window.setInterval(tick, 1000);
})();